import React from 'react';

function CameraIcon(props: object) {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.53125 5.90625H5.90625L8.4375 1.6875H18.5625L21.0938 5.90625H24.4688H27V8.4375V21.0938C27 23.4237 25.1112 25.3125 22.7812 25.3125H4.21875C1.8888 25.3125 0 23.4237 0 21.0938V8.4375V5.90625H2.53125ZM8.07678 7.20856L9.87068 4.21875H17.1293L18.9233 7.20856L19.6606 8.4375H21.0938H24.4688V21.0938C24.4688 22.0258 23.7133 22.7812 22.7812 22.7812H4.21875C3.28678 22.7812 2.53125 22.0258 2.53125 21.0938V8.4375H5.90625H7.33943L8.07678 7.20856ZM16.4531 14.3438C16.4531 15.9747 15.131 17.2969 13.5 17.2969C11.869 17.2969 10.5469 15.9747 10.5469 14.3438C10.5469 12.7128 11.869 11.3906 13.5 11.3906C15.131 11.3906 16.4531 12.7128 16.4531 14.3438ZM18.9844 14.3438C18.9844 17.3726 16.5289 19.8281 13.5 19.8281C10.4711 19.8281 8.01562 17.3726 8.01562 14.3438C8.01562 11.3148 10.4711 8.85938 13.5 8.85938C16.5289 8.85938 18.9844 11.3148 18.9844 14.3438Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CameraIcon;
